import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=ef533944&scoped=true&"
import script from "./AlertBox.vue?vue&type=script&lang=js&"
export * from "./AlertBox.vue?vue&type=script&lang=js&"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=ef533944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef533944",
  null
  
)

export default component.exports